import {
	Stepper,
	StepperNav,
	StepperTrigger,
	StepperItem,
	StepperIndicator,
	StepperTitle,
	StepperSeparator,
	StepperProps,
} from "app/components/ui/Stepper/Stepper";
import { ReactNode } from "react";
import { To } from "react-router-dom";
import styles from "./BookingStepper.module.scss";
import classNames from "classnames/bind";
import { useIntl } from "react-intl";

const cx = classNames.bind(styles);

export type Step = {
	key: string;
	to?: To;
	label: ReactNode;
};

export type BookingStepperProps = StepperProps & {
	steps: Step[];
};

export const BookingStepper = ({
	steps,
	value,
	className,
	clickable,
	"aria-label": ariaLabel,
	...props
}: BookingStepperProps) => {
	const { formatMessage } = useIntl();

	const navAriaLabel = ariaLabel ?? formatMessage({ id: "booking.stepper.aria.label" });

	return (
		<Stepper
			clickable={clickable}
			value={value}
			className={cx("booking-stepper", className)}
			{...props}
		>
			<StepperNav aria-label={navAriaLabel}>
				{steps.map((step, index) => {
					const isLast = index === steps.length - 1;

					return (
						<StepperItem key={step.key} step={index} to={step.to}>
							<StepperTrigger>
								<StepperIndicator />

								<StepperTitle variant="xsmall" variantMD="small">
									{step.label}
								</StepperTitle>
							</StepperTrigger>

							{!isLast && <StepperSeparator />}
						</StepperItem>
					);
				})}
			</StepperNav>
		</Stepper>
	);
};
